var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M17.62 9.211c0-.61-.049-1.223-.154-1.823H9.003v3.455h4.846c-.2 1.114-.847 2.1-1.793 2.726v2.242h2.891c1.698-1.563 2.674-3.87 2.674-6.6z",
    transform: "translate(-124 -158) translate(118 152) translate(6 6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M9.003 17.977c2.42 0 4.46-.795 5.948-2.166l-2.892-2.242c-.804.547-1.843.857-3.052.857-2.341 0-4.326-1.579-5.038-3.702H.986v2.311c1.523 3.03 4.625 4.942 8.017 4.942z",
    transform: "translate(-124 -158) translate(118 152) translate(6 6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC04",
    d: "M3.966 10.724c-.376-1.114-.376-2.32 0-3.435V4.978H.986c-1.273 2.535-1.273 5.522 0 8.057l2.98-2.31z",
    transform: "translate(-124 -158) translate(118 152) translate(6 6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M9.003 3.584c1.28-.02 2.516.461 3.442 1.345l2.562-2.562C13.385.844 11.232.007 9.003.033 5.611.033 2.51 1.945.986 4.978l2.98 2.311c.709-2.126 2.697-3.705 5.037-3.705z",
    transform: "translate(-124 -158) translate(118 152) translate(6 6)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.8497efc4a89c45328718c1cef1ad8b9c.svg";
export { ForwardRef as ReactComponent };